import { render, staticRenderFns } from "./min-score-level.vue?vue&type=template&id=4d78284c&scoped=true"
import script from "./min-score-level.vue?vue&type=script&lang=js"
export * from "./min-score-level.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d78284c",
  null
  
)

export default component.exports